export default __webpack_public_path__ + "static/media/modern.d17098e8.jpg";